import { excludedLinkPrefixMaxCount, excludedLinkPrefixMaxLength } from "./constants";
import type { ExcludedLinkPrefixesValidationResult } from "./types";

export const validateExcludedLinkPrefixes = (prefixes: readonly string[]): ExcludedLinkPrefixesValidationResult => {
  const duplicateRowIndices = new Set<number>();
  const overlongRowIndices = new Set<number>();
  const firstRowByPrefix = new Map<string, number>();
  let nonblankCount = 0;

  prefixes.forEach((rawPrefix, index) => {
    const prefix = rawPrefix.trim();
    if (prefix === "") {
      return;
    }

    nonblankCount += 1;
    if (Array.from(prefix).length > excludedLinkPrefixMaxLength) {
      overlongRowIndices.add(index);
    }

    const firstRow = firstRowByPrefix.get(prefix);
    if (firstRow === undefined) {
      firstRowByPrefix.set(prefix, index);
    } else {
      duplicateRowIndices.add(firstRow);
      duplicateRowIndices.add(index);
    }
  });

  const exceedsCountLimit = nonblankCount > excludedLinkPrefixMaxCount;

  return {
    duplicateRowIndices,
    overlongRowIndices,
    exceedsCountLimit,
  };
};
